import { msalAuthProvider } from 'services/MsalAuthProvider';
import {
  setIsLoading,
  acquiredEmployeeDetailsSuccess,
  setError
} from './aad-slice';
import { getEmployeeDetails } from 'api/aad';
import { getErrors } from 'api/client';

import type { TError } from 'api/client';

export const getEmployeeDetailsThunk = () => async (dispatch) => {
  try {
    dispatch(setIsLoading());
    const token = await msalAuthProvider.getAccessToken();
    const response = await getEmployeeDetails(token.accessToken);
    dispatch(acquiredEmployeeDetailsSuccess(response));

    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e as TError);
    errors && dispatch(setError(errors));

    return Promise.reject(errors);
  }
};
